import React from "react";
import axios from "axios";

import Config from "../../config/Config.js";
import ProjectCard from "./ProjectCard";
import SweetLoadingSpinner from '../eyeCandy/SweetLoadingSpinner';


class ProjectList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      project_list: [],
      loading: true
    };
  }

  componentDidMount() {
    const limit = this.props.limit || 12;
    const ordering = this.props.ordering || '';
    let url = `${Config().baseUrl}?publish=${this.props.publish}&limit=${limit}`;
    if (ordering) url += `&ordering=${ordering}`;

    // If shuffling, fetch more than needed so the random sample is interesting
    const fetchLimit = this.props.shuffle ? Math.max(limit * 4, 40) : limit;
    const fetchUrl = this.props.shuffle
      ? `${Config().baseUrl}?publish=${this.props.publish}&limit=${fetchLimit}`
      : url;

    axios.get(fetchUrl)
      .then(res => {
        let results = res.data.results || [];
        if (this.props.shuffle) {
          // Fisher-Yates shuffle, then take the requested limit
          for (let i = results.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [results[i], results[j]] = [results[j], results[i]];
          }
          results = results.slice(0, limit);
        }
        this.setState({
          project_list: results,
          loading: false
        });
      })
      .catch(err => {
        console.error('ProjectList Load Error:', err);
        console.error('ProjectList Load Error Response:', err.response);
        console.error('ProjectList Load Error Status:', err.response?.status);
        console.error('ProjectList Load Error Data:', err.response?.data);

        this.setState({
          project_list: [],
          loading: false
        });
      });
  }

  render() {
    return (
      <div>
        <SweetLoadingSpinner loadingState={this.state.loading} />
        <div className="row">
          {this.state.project_list.map(project => {
            return <ProjectCard project={project} key={project.id} colClass="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-xs-12" />;
          })}
        </div>
      </div>
    );
  }
}

export default ProjectList;
